<template>
  <validation-observer
    ref="formModalObserver"
    novalidate
    tag="form"
    @submit.prevent="handleModalSubmit"
  >
    <div class=" ">
      <div class="p-2">
        <div class="bg-white border-radius--light py-2">
          <div class="col-12 mb-2 pl-4 pt-3">
            <em class="fas fa-times-square text-orange mr-1" />
            <span class="ml-2">Asignar Referido</span>
          </div>

          <div class="row p-4">
            <div class="col-sm-5">
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <custom-drop-down
                  id="forAdmission"
                  v-model="model.specialist"
                  custom-error-msg="Favor seleccionar especialista para Admisión"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Especialista para Admisión:"
                  :options="specialists"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div class="col-sm">
              <div class="d-flex justify-content-end mt-4">
                <action-button
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="danger mr-2"
                  @click="dispose"
                />
                <action-button
                  text="Asignar"
                  variant="success pl-4 pr-4"
                  @click="assign"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomDropDown from '@/components/common/form/CustomDropDown';
import alert from '@/mixins/alert.mixin';

export default {
  components: {
    CustomDropDown,
  },
  mixins: [alert],
  props: {
    specialists: {
      type: Array,
      default: () => [],
    },
    dispose: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    save: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    selectedSpecialistId: {
      type: Number,
      default: function() {
        return () => null;
      },
    },
  },
  data() {
    return {
      model: {},
    };
  },
  watch: {
    specialists() {
      this.onSelectedSpecialistUpdate(this.selectedSpecialistId);
    },
  },
  methods: {
    async assign() {
      const isValid = await this.$refs.formModalObserver.validate();

      if (!isValid) {
        this.ShowToast('Atención', 'Información Incompleta.', 'error');
        return;
      }
      this.save(this.model.specialist.id);
    },
    onSelectedSpecialistUpdate(selectedSpecialistId) {
      if (selectedSpecialistId > 0) {
        const specialistSelected = this.specialists.find(
          (spec) => spec.id == selectedSpecialistId
        );
        this.model.specialist = { ...specialistSelected };
      }
    },
  },
};
</script>
